<template>
  <BaseCard
    :heading="$t('global.details')"
    :loading="!order"
  >
    <Flex
      align="center"
      :gap="2"
    >
      <Flex
        direction="column"
        :gap="0.5"
      >
        <BaseHeading size="s">{{ $t('global.date') }}</BaseHeading>
        <BaseText v-test="'sale-date'">
          {{ filters.dateTime(order.invoicedAt) }}
        </BaseText>
      </Flex>
      <Flex
        v-if="order?.employeeNames"
        direction="column"
        :gap="0.5"
      >
        <BaseHeading size="s">{{ $t('global.employee') }}</BaseHeading>
        <BaseText v-test="'sale-employees'">{{ order.employeeNames }}</BaseText>
      </Flex>
      <Flex
        v-if="order?.number"
        direction="column"
        :gap="0.5"
      >
        <BaseHeading size="s">{{ $t('global.number') }}</BaseHeading>
        <BaseText v-test="'sale-number'">{{ order.number }}</BaseText>
      </Flex>
      <Flex
        v-if="order?.location?.internalName && multiLocation"
        direction="column"
        :gap="0.5"
      >
        <BaseHeading size="s">{{ $t('global.items.location') }}</BaseHeading>
        <BaseText v-test="'sale-location'">
          {{ order.location.internalName }}
        </BaseText>
      </Flex>
    </Flex>
  </BaseCard>
</template>

<script
  setup
  lang="ts"
>
import filters from '@/filters';
import { useCompanyStore } from '@/stores/company';
import type { Order } from '@/types';

const props = defineProps<{
  order: Order | null;
}>();

const { multiLocation } = useCompanyStore();
</script>
